import api from './api';

export const kcService = {
  async getAllKcs() {
    const response = await api.get('/kcs');
    return response.data;
  },

  async getKcById(id) {
    const response = await api.get(`/kcs/${id}`);
    return response.data;
  },

  async getLocationsByKc(kcId) {
    const response = await api.get(`/kcs/${kcId}/locations`);
    return response.data;
  },

  async getAllLocations() {
    const response = await api.get('/kcs/locations');
    return response.data;
  }
};